import { Container } from "@mui/material";
import { useEffect, useState } from "react";
import { Backend } from "../../services/Backend";
import { Link, useNavigate, useParams } from "react-router-dom";

import Loader from "../../components/Loader";
import moment from "moment";
import ReactQuill from "react-quill";

export default function NewsPreviewPage() {
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();
    const { id } = useParams();
    const [news, setNews] = useState({});

    useEffect(() => {
        Backend.get(`news/${id}`)
            .then(res => {
                Backend.download(`attachment/${res.photo}`)
                    .then(file => {
                        res.photo = URL.createObjectURL(file);
                        setNews(res);
                        setIsLoading(false);
                    });
            });
    }, []);

    const backHandler = (e) => {
        e.preventDefault();

        navigate(-1);
    }

    return <Container maxWidth="lg" className="my-5">
        <Link to="#" onClick={backHandler}>Back</Link>
        <br />
        {isLoading ? <div className="mx-auto w-fit"><Loader /></div>
        : <>
            <b className="text-4xl">{news.title} </b>
            <br />
            <i>{moment(news.uploadDate).local().format("YYYY-MM-DD")}</i>
            <br />
            <br />
            <img src={news.photo} className="w-[100%]"/>
            <br />
            <ReactQuill
                value={news.description}
                readOnly={true}
                theme={"bubble"}
            />
           
            <br />
        </> }

    </Container>
}